const config = {
    build_number: '601442',
    build_timestamp: '2025-05-07T19:19:25.132Z',
    build_commit: 'f5db40b1557e0c1cf160eb6d083bdd139e0751e1',
};

// locally, the build number is always 4122 (which allows us to load non-English content locally)
if (Number.isNaN(parseInt(config.build_number, 10))) {
    config.build_number = '4122';
}

export default config;
